<template>
  <div v-if="visible">

    <!-- Errors -->
    <div v-if="errorsExist" class="alert alert-danger alert-dismissible em-12" role="alert" v-cloak>
      <button type="button" class="close" @click="close">×</button>
      <div v-for="(form_error, i) in form_errors" :key="i">
        {{ form_error }}
      </div>
    </div>

    <!-- Success -->
    <div v-if="form_status" class="alert alert-success alert-dismissible" v-cloak>
      <button type="button" class="close" @click="close">×</button>
      {{ form_status }}
    </div>

    <!-- Info -->
    <div v-if="messagesExist" class="alert alert-info alert-dismissible" v-cloak>
      <button type="button" class="close" @click="close">×</button>
      <div v-for="(form_message, i) in form_messages" :key="i">
        {{ form_message }}
      </div>
    </div>

  </div>
</template>

<script>
export default {
  props: {
    form_errors: {
      type: Array,
      default: () => [],
    },
    form_status: {
      type: String,
      default: '',
    },
    form_messages: {
      type: Array,
      default: () => [],
    },
    auto_hide_ms: {
      type: Number,
      default: 10000,
    },
  },

  data() {
    return {
      visible: true,
      timer: null,
    };
  },

  computed: {
    errorsExist() {
      return this.form_errors && this.form_errors.length > 0;
    },
    messagesExist() {
      return this.form_messages && this.form_messages.length > 0;
    },
    hasContent() {
      return this.errorsExist || this.form_status || this.messagesExist;
    },
  },

  watch: {
    hasContent(newVal) {
      if (newVal) {
        this.show();
      }
    },
  },

  mounted() {
    if (this.hasContent) {
      this.show();
    }
  },

  beforeDestroy() {
    this.clearTimer();
  },

  methods: {
    show() {
      this.visible = true;
      this.clearTimer();

      if (this.auto_hide_ms > 0) {
        this.timer = setTimeout(() => {
          this.visible = false;
        }, this.auto_hide_ms);
      }
    },

    close() {
      this.visible = false;
      this.clearTimer();
    },

    clearTimer() {
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// app-message-list.vue?58d3b840